import FormItem from './form-item.vue'

export default FormItem
